// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/transfer_credits_to_project.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/transfer_credits_to_project.proto.
 */
export const file_vision_billing_v1_transfer_credits_to_project: GenFile = /*@__PURE__*/
  fileDesc("CjN2aXNpb24vYmlsbGluZy92MS90cmFuc2Zlcl9jcmVkaXRzX3RvX3Byb2plY3QucHJvdG8SGHByb3Rvcy52aXNpb24uYmlsbGluZy52MSKiAQofVHJhbnNmZXJDcmVkaXRzVG9Qcm9qZWN0UmVxdWVzdBJQCgZwYXJhbXMYASABKAsyQC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuVHJhbnNmZXJDcmVkaXRzVG9Qcm9qZWN0UmVxdWVzdC5QYXJhbXMaLQoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSDwoHY3JlZGl0cxgCIAEoAyKzAQogVHJhbnNmZXJDcmVkaXRzVG9Qcm9qZWN0UmVzcG9uc2USUQoGcmVzdWx0GAEgASgLMkEucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlRyYW5zZmVyQ3JlZGl0c1RvUHJvamVjdFJlc3BvbnNlLlJlc3VsdBo8CgZSZXN1bHQSGQoRcHVyY2hhc2VkX2JhbGFuY2UYASABKAMSFwoPcHJvamVjdF9iYWxhbmNlGAIgASgDYgZwcm90bzM");

/**
 * @generated from message protos.vision.billing.v1.TransferCreditsToProjectRequest
 */
export type TransferCreditsToProjectRequest = Message<"protos.vision.billing.v1.TransferCreditsToProjectRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.TransferCreditsToProjectRequest.Params params = 1;
   */
  params?: TransferCreditsToProjectRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.TransferCreditsToProjectRequest.
 * Use `create(TransferCreditsToProjectRequestSchema)` to create a new message.
 */
export const TransferCreditsToProjectRequestSchema: GenMessage<TransferCreditsToProjectRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_transfer_credits_to_project, 0);

/**
 * @generated from message protos.vision.billing.v1.TransferCreditsToProjectRequest.Params
 */
export type TransferCreditsToProjectRequest_Params = Message<"protos.vision.billing.v1.TransferCreditsToProjectRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: int64 credits = 2;
   */
  credits: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.TransferCreditsToProjectRequest.Params.
 * Use `create(TransferCreditsToProjectRequest_ParamsSchema)` to create a new message.
 */
export const TransferCreditsToProjectRequest_ParamsSchema: GenMessage<TransferCreditsToProjectRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_transfer_credits_to_project, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.TransferCreditsToProjectResponse
 */
export type TransferCreditsToProjectResponse = Message<"protos.vision.billing.v1.TransferCreditsToProjectResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.TransferCreditsToProjectResponse.Result result = 1;
   */
  result?: TransferCreditsToProjectResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.TransferCreditsToProjectResponse.
 * Use `create(TransferCreditsToProjectResponseSchema)` to create a new message.
 */
export const TransferCreditsToProjectResponseSchema: GenMessage<TransferCreditsToProjectResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_transfer_credits_to_project, 1);

/**
 * @generated from message protos.vision.billing.v1.TransferCreditsToProjectResponse.Result
 */
export type TransferCreditsToProjectResponse_Result = Message<"protos.vision.billing.v1.TransferCreditsToProjectResponse.Result"> & {
  /**
   * @generated from field: int64 purchased_balance = 1;
   */
  purchasedBalance: bigint;

  /**
   * @generated from field: int64 project_balance = 2;
   */
  projectBalance: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.TransferCreditsToProjectResponse.Result.
 * Use `create(TransferCreditsToProjectResponse_ResultSchema)` to create a new message.
 */
export const TransferCreditsToProjectResponse_ResultSchema: GenMessage<TransferCreditsToProjectResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_transfer_credits_to_project, 1, 0);

